import React, { useState } from 'react';
import {
  about,
  about1,
  about2,
  about3,
  flag1,
  flag2,
  flag3,
  flag4,
  flag5,
  flag6,
  flag7,
  flag8,
  flag9,
  hospital5,
  hospital6,
  logoAbout, 
  opportunity1,
  opportunity2,
  opportunity3,
  opportunity4,
  partners1,
  partners2,
  partners3,
  partners4,
  partners5,
  product1,
  product2,
  product3,
  product4,
  sertifikat1,
  sertifikat2,
  sertifikat3,
  sertifikat4,
  sertifikat5,
  sertifikat6,
  service1,
  service2,
  service3,
  service4,
  service5,
  service6,
  why1,
  why2,
  why3,
  why4,
  why5,
  why6,
  why7,
  why8,
  why9
} from '../../assets/images';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const opportunitiesData = [
  { id: 1, image: service1,  title: "Azərbaycanda Təcrübə İmkanları", description: "Xaricdən gələn həkimlər və tibb tələbələri üçün Azərbaycanda yüksək səviyyəli tibb müəssisələrində təcrübə keçmək imkanı yaradırıq. Bu, Azərbaycan səhiyyə sistemini tanımaq və yerli mütəxəssislərlə birgə işləmək şansı təqdim edir." },
  { id: 2, image: service2, title: "Xaricdə Təcrübə İmkanları", description: "Azərbaycanın həkimləri və tibb tələbələri üçün beynəlxalq klinikalar və tibbi mərkəzlərdə təcrübə keçmək imkanı təqdim edirik. Bu proqram qlobal səhiyyə standartlarını öyrənməyə və beynəlxalq təcrübə qazanmağa imkan verir." },
  { id: 3, image: service3, title: "Qlobal Sanatoriya Şəbəkəsi", description: "Dünyanın müxtəlif ölkələrində yerləşən sanatoriya və sağlamlıq mərkəzləri ilə əməkdaşlıq quraraq xəstələr üçün müalicəvi istirahət imkanları yaradırıq. Rahatlıq və sağlamlıq arasında balans qurmaq istəyənlər üçün ideal seçimdir." },
  { id: 4, image: service4, title: "Azərbaycanda Tibbi Müalicə", description: "Xaricdən gələn xəstələr üçün Azərbaycanda yüksək səviyyəli müasir tibbi xidmətlər təklif edirik. Müxtəlif ixtisaslar üzrə ixtisaslaşmış həkimlərimiz və təchizatlı tibb mərkəzlərimiz ilə xəstələrin ehtiyaclarına uyğun həllər təqdim edirik." },
  { id: 5, image: service5, title: "Xaricdə Tibbi Müalicə", description: "Azərbaycanın hüdudlarından kənarda, dünyanın qabaqcıl tibbi müəssisələrində xəstələr üçün müalicə proseslərini təşkil edirik. Əməkdaşlıq etdiyimiz beynəlxalq klinikalar və mütəxəssislər vasitəsilə ən müasir tibbi xidmətlərdən faydalanmaq imkanı yaradırıq." },
  { id: 6, image: service6, title: "Qlobal Həkim Mübadiləsi", description: "Dünyanın müxtəlif ölkələri arasında həkimlərin təcrübə və bilik mübadiləsini təşkil edirik. Bu xidmət çərçivəsində həm xaricdən xaricə, həm də Azərbaycandan xaricə və xaricdən Azərbaycana həkimlər göndərərək beynəlxalq tibbi əməkdaşlığı genişləndiririk." },
];

const Services = () => {
  const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);
    const [showText, setShowText] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const flags = [
      { id: 1, image: flag1,  },
          { id: 2, image: flag2,},
          { id: 3, image: flag3, }, 
          { id: 4, image: flag4,},
          { id: 5, image: flag5,},
          { id: 6, image: flag6, },
              { id: 7, image: flag7, },
                  { id: 8, image: flag8, },
                      { id: 9, image: flag9, },
    ];
      const partners = [partners1, partners2, partners3, partners4, partners5, hospital5, hospital6];


  return (

     <div className="md:max-w-container max-w-containerSm mx-auto mt-[24px] md:mt-[56px]">
          <p >Ana səhifə <i className={`fas fa-chevron-right text-[black] ml-3 mr-3`}/> {t("Xidmətlər")}</p>
          <div>
          <div className="max-w-container mx-auto mt-[24px] md:mt-[56px] hidden md:block">
      <div className="flex items-center justify-between ">
        <p className="text-[46px] font-medium text-center mx-auto">{t("Xidmətlərimiz")}</p>
      </div>
      <div className="grid grid-cols-3 mt-10 gap-10">
        {opportunitiesData.map((item) => (
          <div key={item.id} className="rounded-[20px] py-4 w-[400px] min-h-[220px] px-3 shadow bg-white">
            <img className="h-[50px] w-[50px] mx-auto" src={item.image} alt="Opportunity" />
            <div>
              <p className="mt-[12px] text-[22px] font-medium text-center">{t(item.title)}</p>
              <p className="mt-[12px] mb-[32px] text-center">
                {t(item.description)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
     <div className="max-w-containerSm mx-auto mt-[64px] md:mt-[104px] block md:hidden">
     <p className="text-3xl font-medium text-center mb-8">{t("Xidmətlərimiz")}</p>
     <Swiper
      slidesPerView={1}
      spaceBetween={20}
      loop={true}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      onSlideChange={(swiper) => {
        setShowText(false);
        setShowButton(false); 
        setActiveIndex(swiper.activeIndex);
      }}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
    >
      {opportunitiesData.map((slide, index) => (
        <SwiperSlide key={index}>
       <div key={slide.id} className="rounded-[20px] py-4 px-3 shadow bg-white">
            <img className="h-[50px] w-[50px] mx-auto" src={slide.image} alt="Opportunity" />
            <div>
              <p className="mt-[12px] text-[22px] font-medium text-center">{t(slide.title)}</p>
              <p className="mt-[12px] mb-[32px] text-center">
                {t(slide.description)}
              </p>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
    <a href='/services'>
          <button className='h-[51px] w-full md:w-[164px] rounded-[12px] mt-8 bg-[#FB8C00] text-white'>{t("Hamısına bax")}</button>
        </a>
        </div>
          </div>
            <div className="md:max-w-container md:mt-[104px] mt-[64px] max-w-containerSm mx-auto">
                <p className="text-black text-3xl md:text-[46px] font-medium text-center mb-8 md:mb-0">
                {t("Partnyorlarımız")}
                </p>
                <div className="block mt-[56px] gap-[64px] md:flex">
                  {partners.map((flag, index) => (
                    <div key={index} >
                      <img className="h-[60px] mx-auto mt-8 md:mx-0 md:mt-0" src={flag} alt={`Flag ${index + 1}`} />
                    </div>
                  ))}
                </div>
              </div>
                <div className="md:max-w-container md:mt-[104px] mt-[64px] max-w-containerSm mx-auto">
                    <p className="text-black text-3xl md:text-[46px] font-medium text-center mb-8 md:mb-0">
                      {t("Beynəlxalq Əməkdaşlıqlarımız")}
                    </p>
                  <div className="hidden md:block mt-[56px]">
                    <Swiper
                      slidesPerView={6}
                      spaceBetween={20}
                      loop={true}
                      autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                      }}
                      navigation={true}
                      modules={[Autoplay, Pagination, Navigation]}
                      className="mySwiper"
                    >
                      {flags.map((flag, index) => (
                        <SwiperSlide key={flag.id}>
                          <a href={`/partners/${flag.id}`}>
                            <img
                              className="h-[128px] w-[194px]"
                              src={flag.image}
                              alt={`Flag ${index + 1}`}
                            />
                          </a>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                    <div className='block md:hidden'>
                     <Swiper
                         slidesPerView={1}
                         spaceBetween={20}
                         loop={true}
                         autoplay={{
                           delay: 4000,
                           disableOnInteraction: false,
                         }}
                         pagination={{
                           clickable: true,
                         }}
                         onSlideChange={(swiper) => {
                           setShowText(false);
                           setShowButton(false); 
                           setActiveIndex(swiper.activeIndex);
                         }}
                         modules={[Autoplay, Pagination, Navigation]}
                         className="mySwiper"
                       >
                         {flags.map((slide, index) => (
                           <SwiperSlide key={index}>
                           <a href={`/partners/${slide.id}`}>
                           <div key={index}>
                          <img  src={slide.image} alt={`Flag ${index + 1}`} />
                        </div>
                           </a>
                           </SwiperSlide>
                         ))}
                       </Swiper>
                    </div>
                  </div>
         
        </div>
  );
};

export default Services;